import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {UserRolesRestService} from '../../services/userrole/user-roles-rest.service';
import {UserRole} from '../../types/userrole/user-role';

@Component({
  selector: 'wsd-select-roles',
  templateUrl: './select-roles.component.html',
  styleUrls: ['./select-roles.component.css']
})
export class SelectRolesComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_ROLE.LABEL';

  @Input()
  controlName: string = 'roles';

  @Input()
  initialRegionId: number;

  @Input()
  showLabel: boolean = true;

  @Input()
  regionId: number;

  @Input()
  organizationId: number;

  @Output()
  private onChange = new EventEmitter<void>();

  roleItems: SelectItem[] = [];

  constructor(private userService: UserRolesRestService) {
  }

  ngOnInit() {
    this.loadRoles();
  }

  private loadRoles() {
    this.userService.getAvailableUserRoles(this.regionId, this.organizationId).subscribe(
      (roles: UserRole[]) => {
        this.roleItems = roles.map(role => {
          return {
            label: role.name,
            value: role
          };
        });
      }
    );
  }

  change() {
    this.onChange.emit();
  }

  reloadRoles() {
    this.loadRoles();
  }

}
